import { useMemo } from 'react'
import { useAuth } from '@/context/AuthProvider'

export function useEntitlements() {
  const { user, profilePlan, isPremium } = useAuth()

  return useMemo(() => ({
    plan: profilePlan,
    isPremium,
    canUseCloudSync: isPremium,
    canUsePublicationExport: isPremium,
    canUseRemoteAi: Boolean(user),
  }), [isPremium, profilePlan, user])
}
